class DZModelAbout{
    /**
     * 主键
     */
    id = "";

    /**
     * 标题
     */
    title = "";

    /**
     * 内容
     */
    content = "";

    type = ""

    status:any = undefined ;

}export default DZModelAbout
